import React from 'react';
import { FormattedMessage } from 'react-intl';
import { get } from 'lodash';
import InboxTransitionBase from './InboxTransitionBase';
import { getFirstName } from '../../util/user';

const InboxTransitionRequestedChanges = ({ transition, user, ownRole, buttons }) => {
  const isOwnTransition = transition.by === ownRole;
  const displayName = get(user, 'attributes.profile.displayName', '');
  const firstName = getFirstName(displayName);

  return (
    <InboxTransitionBase
      header={
        isOwnTransition ? (
          <FormattedMessage
            id="BookingStatus.ownTransitionCustomerRequestedChanges"
            values={{ displayName: firstName }}
          />
        ) : (
          <FormattedMessage
            id="BookingStatus.transitionCustomerRequestedChanges"
            values={{ displayName: firstName }}
          />
        )
      }
      date={transition.createdAt}
      direction="right"
      variation="dark"
      buttons={buttons}
    >
      {isOwnTransition ? (
        <FormattedMessage
          id="BookingStatus.ownTransitionCustomerRequestedChangesSubtext"
          values={{ displayName: firstName }}
        />
      ) : (
        <FormattedMessage
          id="BookingStatus.transitionCustomerRequestedChangesSubtext"
          values={{ displayName: firstName }}
        />
      )}
    </InboxTransitionBase>
  );
};

export default InboxTransitionRequestedChanges;
